import { Link } from "react-router-dom"
import { BASE_URL } from "./Alerts/Alerts"
import { useSelector } from "react-redux"
import { selectWebsiteData } from "../redux/general/selectors"
import { forwardRef } from "react"
import { useNavigate } from "react-router-dom"

const AppLogo = forwardRef(() => {
    const websiteData = useSelector(selectWebsiteData)
    const navigate = useNavigate()
    return (
        <>
            <Link
                className="header-brand1"
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: 1,
                    margin: 0,
                    padding: 0,
                }}
                onClick={() => {
                    localStorage.removeItem("app")
                    localStorage.removeItem("viewMode")
                    localStorage.removeItem("menuitems") // The menuitems are removed from localstorage when a user clicks on logo.
                    // window.location.href = `/`
                    navigate("/")
                }}
                to="/"
            >
                {websiteData?.logo ? (
                    <img
                        src={`${BASE_URL}${websiteData?.logo}`}
                        className="desktop-logo e-header-log"
                        alt="logo1"
                        style={{
                            maxHeight: "55px",
                            maxWidth: "180px",
                            width: "auto",
                            height: "auto",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                ) : (
                    <span
                        style={{
                            fontSize: "1.2rem",
                            fontWeight: "bold",
                            lineHeight: 1,
                        }}
                    >
                        {websiteData?.name}
                    </span>
                )}
            </Link>
        </>
    )
})

export default AppLogo
